import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ServiceOptinStatData } from '../../shared/types';
import { MobileDetectionMixin } from '../../shared/mixins/mobile-detection.mixin';

@Component({
  selector: 'app-service-optin-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './service-optin-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./service-optin-card.component.scss'],
})
export class ServiceOptinCardComponent extends MobileDetectionMixin {
  @Input() data!: ServiceOptinStatData;
}
